import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { isValidArray, mapMstToOptions, pageInitSize } from "utils/HelperFunction";
import { debounce } from "@mui/material";
import { initFinancialStatusCount } from "mocks/grData";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { getAllExpensePagination } from "../../redux/slices/logic/getAllExpensePagination.slice";
export default function useInitExpDataList(param) {
    var initStatus = param.initStatus;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState([]), 2), tab = _useState[0], setTab = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), data = _useState1[0], setData = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        page: 1,
        pageSize: pageInitSize,
        total: 0
    }), 2), pageModel = _useState2[0], setPageModel = _useState2[1];
    var _useState3 = _sliced_to_array(useState(initStatus), 2), btnempstatus = _useState3[0], setBtnempstatus = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState4[0], setSelectedGroupOfSuplierID = _useState4[1];
    var _useState5 = _sliced_to_array(useState(initFinancialStatusCount), 2), expenseStatusCount = _useState5[0], setExpenseStatusCount = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), filterText = _useState6[0], setFilterText = _useState6[1];
    // Reducers
    var reducers = {
        expensePagination: useAppSelector(function(state) {
            return state.getAllExpensePaginationReducer;
        })
    };
    var isInitExpLoading = useMemo(function() {
        return reducers.expensePagination.isFetching;
    }, [
        reducers.expensePagination.isFetching
    ]);
    var getData = useCallback(function(page, limit, searchText, groupSubID, statusID) {
        var queryParams = {
            mstNewStatusID: statusID,
            page: page || pageModel.page,
            limit: limit || pageModel.pageSize,
            searchText: searchText,
            groupSubID: groupSubID || ""
        };
        dispatch(getAllExpensePagination({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        getData(1, pageModel.pageSize, "", "", btnempstatus);
    }, []);
    useEffect(function() {
        if (reducers.expensePagination.data) {
            var result = reducers.expensePagination.data.data.data;
            var meta = reducers.expensePagination.data.data.meta;
            var expenseStatusCount = reducers.expensePagination.data.data.expenseStatusCount;
            setData(result);
            setPageModel({
                page: meta.page,
                pageSize: meta.limit,
                total: meta.total
            });
            // console.log(result)
            setTab(result);
            setExpenseStatusCount(expenseStatusCount);
        }
    }, [
        reducers.expensePagination.data
    ]);
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText, selectedGroupOfSuplierID, btnempstatus) {
            getData(1, pageModel.pageSize, searchText, selectedGroupOfSuplierID, btnempstatus);
        }, 300);
    }, []);
    useEffect(function() {
        if (filterText !== null) {
            debouncedSearch(filterText || "", selectedGroupOfSuplierID, btnempstatus);
        }
    }, [
        filterText
    ]);
    useEffect(function() {
        getData(1, pageModel.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus);
    }, [
        selectedGroupOfSuplierID,
        btnempstatus
    ]);
    return {
        pageModel: pageModel,
        setPageModel: setPageModel,
        filterText: filterText,
        setFilterText: setFilterText,
        data: data,
        setData: setData,
        btnempstatus: btnempstatus,
        setBtnempstatus: setBtnempstatus,
        getData: getData,
        expenseStatusCount: expenseStatusCount,
        isInitExpLoading: isInitExpLoading,
        selectedGroupOfSuplierID: selectedGroupOfSuplierID,
        setSelectedGroupOfSuplierID: setSelectedGroupOfSuplierID,
        setExpenseStatusCount: setExpenseStatusCount
    };
}
